/**
 * @file Builds the form schema for a US address.
 */

import {
  COUNTRY_US,
  US_STATE_OPTIONS,
  LABEL_STATE_PLACEHOLDER,
} from "@components/Address";
import {
  TYPE_ZIP,
  TYPE_STRING,
  TYPE_HIDDEN,
} from "@components/Form";

import type { Address, AddressInput } from "./types";

const STREET_MAX_LENGTH = 50;
const LOCALITY_MAX_LENGTH = 32;
const REGION_INPUT_WIDTH = 180;
const ITEM_WIDTH = "75%";

/**
 * Builds the form schema for a US street address, city, state and ZIP code.
 */
const getUsAddressSchema = (address: Address = {}): AddressInput[] => {
  const {
    postalCode,
    streetAddress,
    addressRegion,
    addressLocality,
  } = address;

  const schema: AddressInput[] = [
    {
      name: "streetAddress",
      type: TYPE_STRING,
      label: "Street",
      maxLength: STREET_MAX_LENGTH,
      itemProps: { style: { width: ITEM_WIDTH } },
      placeholder: "",
      initialValue: streetAddress,
    },
    {
      name: "addressLocality",
      type: TYPE_STRING,
      label: "City",
      maxLength: LOCALITY_MAX_LENGTH,
      itemProps: { style: { width: ITEM_WIDTH } },
      placeholder: "",
      initialValue: addressLocality,
    },
    {
      name: "addressRegion",
      type: TYPE_STRING,
      label: "State",
      options: US_STATE_OPTIONS,
      inputProps: { style: { width: REGION_INPUT_WIDTH } },
      placeholder: LABEL_STATE_PLACEHOLDER,
      initialValue: addressRegion,
    },
    {
      name: "postalCode",
      type: TYPE_ZIP,
      label: "ZIP code",
      placeholder: "",
      initialValue: postalCode,
    },
    {
      name: "addressCountry",
      type: TYPE_HIDDEN,
      placeholder: "",
      initialValue: COUNTRY_US,
    },
  ];

  return schema;
};

export default getUsAddressSchema;
